import React from "react";
import { FunctionFactory } from 'survey-core';
import { WhyConsistency } from "../quiz/whyConsistency";
import { SelfDescription } from '../quiz/describeSelf';

const whyConsistencySplashHtml = `
<div class="new-quote-container">
  <div class="splash-icon">🌟 </div>
  <div class="splash-header">
    <h1>Don’t worry, <div class="highlight">{name}</div></h1>
    <div class="quote">
      You don’t need to sacrifice everything for results. As long as you’re consistent 70-80% of the time, you’ll make great progress.
    </div>
  </div>
</div>`;

const whyConsistencySplashExpression = {
  name: "whyConsistencySplashQuote",
  expression: "renderWhyConsistencySplashQuote({whyConsistency})",
};

function renderWhyConsistencySplashQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  const whyConsistency = params[0] as WhyConsistency;
  if (whyConsistency === WhyConsistency.Time) {
    return `You don't need to sacrifice everything just to get results. As long as you're consistent 70-80% of the time, you can still make great progress.`;
  }
  return "";
}

FunctionFactory.Instance.register("renderWhyConsistencySplashQuote", renderWhyConsistencySplashQuote);

const whyConsistencySplashElement = {
  visibleIf: `{describeSelf} == "${SelfDescription.StruggleConsistency}" and {whyConsistency} == "${WhyConsistency.Time}"`,
  name: 'why-consistency-splash',
  type: 'html',
  html: whyConsistencySplashHtml,
};

const WhyConsistencySplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      🔒 Locking in on your personal prediction
    </div>
  );
};

export {
  whyConsistencySplashElement,
  whyConsistencySplashExpression,
  WhyConsistencySplashHeader,
}